/**
 * Temporary 25-year header mark.
 *
 * Restore the classic LOG wordmark:
 * 1. Set USE_ANNIVERSARY_LOGO to false
 * 2. Delete HeaderLogoAnniversary.js
 * 3. Delete pages/_header-logo-anniversary.scss and its import in main.scss
 * 4. Delete static/videos/log-25-*
 */
export const USE_ANNIVERSARY_LOGO = true

/** Classic wordmark (pre-anniversary). */
export const CLASSIC_HEADER_LOGO = {
  desktop: { width: 100, height: 50 },
  mobile: { width: 80, height: 40 },
}

/**
 * Square 25-year mark including confetti margin.
 * Resting LOG wordmark matches classic 100×50 / 80×40
 * (source LOG is ~794×423 inside 1080).
 */
export const ANNIVERSARY_HEADER_LOGO = {
  desktop: 136,
  mobile: 109,
}
